module.exports = __webpack_public_path__ + "static/img/m12.f048fd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/mobile/m12.png
// module id = bPoI
// module chunks = 12